"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Endpoints = /*#__PURE__*/function () {
  function Endpoints() {
    var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "https://polis.metis.io/";
    _classCallCheck(this, Endpoints);
    this.wsServer = 'wss://polis.metis.io/wss/mts-l2';
    this.confirmUrl = '#/oauth2/confirm';
    this.apiHost = 'https://polis.metis.io/';
    this.oauthRedirectUrl = '#/oauth2-login?';
    if (!host.endsWith('/')) {
      host = host + '/';
    }
    this.apiHost = host;
  }
  _createClass(Endpoints, [{
    key: "getWsServer",
    value: function getWsServer() {
      return this.apiHost.replace("https", "wss").replace("http", "wss") + this.wsServer;
    }
  }, {
    key: "getConfirmUrl",
    value: function getConfirmUrl() {
      return this.apiHost + this.confirmUrl;
    }
  }, {
    key: "getBridgeUrl",
    value: function getBridgeUrl() {
      return this.apiHost + "#/oauth2/bridge";
    }
  }, {
    key: "getApiHost",
    value: function getApiHost() {
      return this.apiHost;
    }
  }, {
    key: "getOauthRedirectUrl",
    value: function getOauthRedirectUrl() {
      return this.apiHost + this.oauthRedirectUrl;
    }
  }]);
  return Endpoints;
}();
exports.default = Endpoints;